/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DocumentReceivedVia = {
    Portal: 'portal',
    Email: 'email',
    Fax: 'fax',
    InPerson: 'in_person',
    Mail: 'mail',
    Other: 'other',
} as const;
export type DocumentReceivedVia = typeof DocumentReceivedVia[keyof typeof DocumentReceivedVia];


export function instanceOfDocumentReceivedVia(value: any): boolean {
    for (const key in DocumentReceivedVia) {
        if (Object.prototype.hasOwnProperty.call(DocumentReceivedVia, key)) {
            if (DocumentReceivedVia[key as keyof typeof DocumentReceivedVia] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DocumentReceivedViaFromJSON(json: any): DocumentReceivedVia {
    return DocumentReceivedViaFromJSONTyped(json, false);
}

export function DocumentReceivedViaFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentReceivedVia {
    return json as DocumentReceivedVia;
}

export function DocumentReceivedViaToJSON(value?: DocumentReceivedVia | null): any {
    return value as any;
}

export function DocumentReceivedViaToJSONTyped(value: any, ignoreDiscriminator: boolean): DocumentReceivedVia {
    return value as DocumentReceivedVia;
}

